import React from "react";

const Collapse = ({
  title,
  children,
  className,
  open = true,
}: {
  title: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  open?: boolean;
}) => {
  const [active, setActive] = React.useState<boolean>(open);
  return (
    <div
      className={`collapse collapse-arrow rounded-box ${className} ${
        active && "!border-primary"
      }`}
    >
      <input
        checked={active}
        onChange={(event) => setActive(event.target.checked)}
        type="checkbox"
        className="peer"
      />
      <div className="collapse-title text-md font-normal">{title}</div>
      <div className="collapse-content w-full">{children}</div>
    </div>
  );
};

export default Collapse;
